import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { BuildPage } from '@/features/docs';

/** Guarded by the `/docs` layout (`docs.read`). `s` is the encoded selection (shareable link). */
export const Route = createFileRoute('/_authed/docs/build')({
  validateSearch: z.object({ s: z.string().optional().catch(undefined) }),
  component: BuildPage,
});
